


import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";
import { Capacitor } from "@capacitor/core";
import AppleSignInButton from "../components/AppleSignInButton";
import {
  VAULTQUEST_AGE_GROUPS,
  isAdultAgeGroup,
} from "../utils/aiConflictConsent";





export default function VQRegisterPage({ onBackToLogin, onRegister, error, onAppleError }) {
  const isNativeAuthLayout = Capacitor.isNativePlatform();
  const { t } = useLanguage();
  const [step, setStep] = useState(0); // 0 = ACCOUNTDATEN, 1 = GAMINGDATEN
  // ACCOUNTDATEN
const [username, setUsername] = useState("");
const [usernameError, setUsernameError] = useState("");
const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [passwordRepeat, setPasswordRepeat] = useState("");
const [passwordError, setPasswordError] = useState("");
const [passwordRepeatError, setPasswordRepeatError] = useState("");
const [age, setAge] = useState("");
const [consoleType, setConsoleType] = useState("");
const touchStartXRef = React.useRef(null);
const touchStartYRef = React.useRef(null);
const mouseDownXRef = React.useRef(null);
const [acceptedLegal, setAcceptedLegal] = useState(false);
const [aiConflictAnalysisConsent, setAiConflictAnalysisConsent] = useState(false);
const [confirmedMinimumAge, setConfirmedMinimumAge] = useState(false);
const mouseDownYRef = React.useRef(null);
  const canUseAiConflictAnalysis = isAdultAgeGroup(age);
  const headerSubTitle =
  step === 0 ? t("register.accountStepTitle") : t("register.gamingStepTitle");
const SWIPE_MIN_X = 55;      // Mindest-Wischdistanz
const SWIPE_MAX_Y = 35;      // damit vertikales Scrollen nicht triggert

const rememberRegisterReturn = (event) => {
  event.stopPropagation();
  window.sessionStorage?.setItem("vaultquest:returnToRegister", "1");
};

useEffect(() => {
  if (!canUseAiConflictAnalysis && aiConflictAnalysisConsent) {
    setAiConflictAnalysisConsent(false);
  }
}, [canUseAiConflictAnalysis, aiConflictAnalysisConsent]);



const onTouchStart = (e) => {
  const t = e.touches?.[0];
  if (!t) return;
  touchStartXRef.current = t.clientX;
  touchStartYRef.current = t.clientY;
};


const onTouchEnd = (e) => {
  const startX = touchStartXRef.current;
  const startY = touchStartYRef.current;
  touchStartXRef.current = null;
  touchStartYRef.current = null;

  if (startX == null || startY == null) return;

  const t = e.changedTouches?.[0];
  if (!t) return;

  const dx = t.clientX - startX;
  const dy = t.clientY - startY;



  // Wenn zu vertikal → ignorieren (damit Scrollen nicht kaputt geht)
  if (Math.abs(dy) > SWIPE_MAX_Y) return;

  // Wenn nicht weit genug → ignorieren
  if (Math.abs(dx) < SWIPE_MIN_X) return;

  // dx < 0 = nach links wischen → nächster Step
  if (dx < 0 && step === 0) setStep(1);

  // dx > 0 = nach rechts wischen → vorheriger Step
  if (dx > 0 && step === 1) setStep(0);
};

const onMouseDown = (e) => {
  mouseDownXRef.current = e.clientX;
  mouseDownYRef.current = e.clientY;
};

const onMouseUp = (e) => {
  const startX = mouseDownXRef.current;
  const startY = mouseDownYRef.current;
  mouseDownXRef.current = null;
  mouseDownYRef.current = null;

  if (startX == null || startY == null) return;

  const dx = e.clientX - startX;
  const dy = e.clientY - startY;

  // vertikale Bewegung ignorieren (Scroll/Drag nach oben/unten)
  if (Math.abs(dy) > 35) return;
  if (Math.abs(dx) < 55) return;

  if (dx < 0 && step === 0) setStep(1);
  if (dx > 0 && step === 1) setStep(0);
};




  const dots = useMemo(() => {
    return (
      <div style={{ display: "flex", gap: 8, alignItems: "center", transition: "opacity 180ms ease" }}>
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: 999,
            background: step === 0 ? "white" : "rgba(255,255,255,0.35)",
          }}
        />
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: 999,
            background: step === 1 ? "white" : "rgba(255,255,255,0.35)",
          }}
        />
      </div>
    );
  }, [step]);

const backToLoginButtonStyle = {
  marginTop: 14,
  width: "100%",
  height: 56,
  borderRadius: 18,
  border: "2px solid rgba(255,255,255,0.65)",
  background: "rgba(255,255,255,0.08)",
  color: "white",
  fontWeight: 1000,
  letterSpacing: 0.9,
  textTransform: "uppercase",
  cursor: "pointer",
};

const renderBackToLoginButton = (styleOverrides = {}) => (
  <button
    type="button"
    onClick={() => onBackToLogin?.()}
    style={{ ...backToLoginButtonStyle, ...styleOverrides }}
  >
    {t("register.backToLogin")}
  </button>
);






// Hier geht richtiger Return los
  return (
    <div
    className={`vq-auth-page vq-auth-register${isNativeAuthLayout ? " is-native" : ""}`}
    onTouchStart={onTouchStart}
    onTouchEnd={onTouchEnd}
    onMouseDown={onMouseDown}
onMouseUp={onMouseUp}
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        background: "#000",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <div
        className="vq-auth-surface"
        style={{
          width: "100%",
          maxWidth: "430px",
          minHeight: "100vh",
          borderRadius: "28px",
          overflow: "hidden",
          background: "linear-gradient(90deg, #080427 0%, #020047 100%)",
          position: "relative",
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          padding: "calc(26px + var(--vq-safe-area-top)) calc(18px + var(--vq-safe-area-right)) calc(26px + var(--vq-safe-area-bottom)) calc(18px + var(--vq-safe-area-left))",
          boxSizing: "border-box",
          fontFamily: "'Cooper Hewitt', system-ui, -apple-system, Arial, sans-serif",
          color: "white",
        }}
      >
        {/* Logo */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: 6 }}>
          <img
            src="/vaultquest-logo.png"
            alt="VaultQuest"
            style={{ width: 120, height: 120, objectFit: "contain" }}
          />
        </div>

        {/* Title */}
        <div
          style={{
            marginTop: 6,
            textAlign: "center",
            fontWeight: 1000,
            letterSpacing: 1,
            textTransform: "uppercase",
            fontSize: 34,
            background: "linear-gradient(90deg, #ff007f 0%, #7a2bff 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("register.title")}
        </div>

        <AppleSignInButton onError={onAppleError} />

        {/* Subtitle + Dots */}
        <div
          style={{
            marginTop: 10,
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: 8,
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              fontWeight: 1000,
              letterSpacing: 1,
              textTransform: "uppercase",
              fontSize: 16,
              opacity: 0.85,
              transition: "opacity 180ms ease, transform 180ms ease",
              transform: step === 0 ? "translateX(0px)" : "translateX(-2px)",
            }}
          >
            {headerSubTitle}
          </div>
          {dots}
        </div>

{/* Content Area */}
<div style={{ marginTop: 22, overflow: "hidden" }}>
  <div
    style={{
      display: "flex",
      width: "200%",
      transform: step === 0 ? "translateX(0%)" : "translateX(-50%)",
      transition: "transform 280ms ease",
    }}
  >
    {/* ================= STEP 0 ================= */}
    <div style={{ width: "50%", boxSizing: "border-box", paddingRight: 10 }}>
      <div style={{ display: "grid", gap: 14 }}>
        <VQInput
          placeholder={t("register.usernamePlaceholder")}
          value={username}
          onChange={(e) => {
  const value = e.target.value;

  setUsername(value);

  const clean = value.trim();
  const lower = clean.toLowerCase();

  const USERNAME_REGEX = /^[a-zA-Z0-9_]{3,15}$/;

  const RESERVED_USERNAMES = [
    "admin",
    "support",
    "vaultquest",
    "official",
    "moderator",
    "system",
  ];

  if (clean.length < 3) {
    setUsernameError(
      t("register.errors.usernameTooShort")
    );
    return;
  }

  if (clean.length > 15) {
    setUsernameError(
      t("register.errors.usernameTooLong")
    );
    return;
  }

  if (!USERNAME_REGEX.test(clean)) {
    setUsernameError(
      t("register.errors.usernameInvalid")
    );
    return;
  }

  if (RESERVED_USERNAMES.includes(lower)) {
    setUsernameError(
      t("register.errors.usernameReserved")
    );
    return;
  }

  setUsernameError("");
}}
        />

        {usernameError && (
  <div
    style={{
      marginTop: -6,
      color: "#ff4d4f",
      fontWeight: 900,
      fontSize: 13,
      letterSpacing: 0.3,
      textAlign: "left",
      paddingLeft: 6,
    }}
  >
    {usernameError}
  </div>
)}

        <VQInput
          placeholder={t("register.emailPlaceholder")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <VQInput
  placeholder={t("register.passwordPlaceholder")}
  type="password"
  value={password}
  onChange={(e) => {
    const value = e.target.value;
    setPassword(value);

    if (value.length > 0 && value.length < 6) {
      setPasswordError(t("register.errors.passwordTooShort"));
    } else {
      setPasswordError("");
    }

    if (passwordRepeat.length > 0 && value !== passwordRepeat) {
      setPasswordRepeatError(t("register.errors.passwordMismatch"));
    } else {
      setPasswordRepeatError("");
    }
  }}
/>

{passwordError && (
  <div
    style={{
      marginTop: -6,
      color: "#ff4d4f",
      fontWeight: 900,
      fontSize: 13,
      letterSpacing: 0.3,
      textAlign: "left",
      paddingLeft: 6,
    }}
  >
    {passwordError}
  </div>
)}

    <VQInput
  placeholder={t("register.passwordRepeatPlaceholder")}
  type="password"
  value={passwordRepeat}
  onChange={(e) => {
    const value = e.target.value;
    setPasswordRepeat(value);

    if (value.length > 0 && value !== password) {
      setPasswordRepeatError(t("register.errors.passwordMismatch"));
    } else {
      setPasswordRepeatError("");
    }
  }}
/>

{passwordRepeatError && (
  <div
    style={{
      marginTop: -6,
      color: "#ff4d4f",
      fontWeight: 900,
      fontSize: 13,
      letterSpacing: 0.3,
      textAlign: "left",
      paddingLeft: 6,
    }}
  >
    {passwordRepeatError}
  </div>
)}

        <button
          type="button"
          onClick={() => setStep(1)}
          style={{
            marginTop: 10,
            width: "100%",
            height: 70,
            borderRadius: 22,
            border: "none",
            background:
              "linear-gradient(90deg, #ff007f 0%, #7a2bff 100%)",
            color: "white",
            fontWeight: 1000,
            fontSize: 22,
            letterSpacing: 1,
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          {t("register.next")}
        </button>
        {step === 0 && renderBackToLoginButton({ marginTop: 0 })}
      </div>
    </div>

    {/* ================= STEP 1 ================= */}
    <div style={{ width: "50%", boxSizing: "border-box", paddingLeft: 10 }}>
      <div style={{ display: "grid", gap: 14 }}>
        <select
          value={consoleType}
          onChange={(e) => setConsoleType(e.target.value)}
          style={{
            height: 62,
            borderRadius: 18,
            background: "white",
            border: "none",
            outline: "none",
            padding: "0 18px",
            fontSize: 16,
            fontWeight: 900,
            letterSpacing: 0.6,
            fontStyle: "italic",
            color: "#222",
            textTransform: "uppercase",
          }}
        >
          <option value="" disabled>
  {t("register.consoleTypePlaceholder")}
</option>
<option value="PLAYSTATION">
  {t("register.consoleOptions.playstation")}
</option>

<option value="XBOX">
  {t("register.consoleOptions.xbox")}
</option>

<option value="PC">
  {t("register.consoleOptions.pc")}
</option>
        </select>

        <div
          style={{
            height: 62,
            borderRadius: 18,
            background: "white",
            display: "flex",
            alignItems: "center",
            padding: "0 18px",
            boxSizing: "border-box",
          }}
        >
          <select
            value={age}
            onChange={(e) => {
              const nextAge = e.target.value;
              setAge(nextAge);
              if (!isAdultAgeGroup(nextAge)) {
                setAiConflictAnalysisConsent(false);
              }
            }}
            style={{
              width: "100%",
              border: "none",
              outline: "none",
              background: "transparent",
              fontSize: 16,
              fontWeight: 900,
              letterSpacing: 0.6,
              fontStyle: "italic",
              color: age ? "#222" : "#777",
              textTransform: "uppercase",
            }}
          >
            <option value="">{t("register.agePlaceholderOptional")}</option>
            {VAULTQUEST_AGE_GROUPS.map((group) => (
              <option key={group} value={group}>
                {group}
              </option>
            ))}
          </select>
        </div>

<button
  type="button"
  onClick={() => setStep(0)}
  style={{
    height: 60,
    borderRadius: 18,
    border: "2px solid rgba(255,255,255,0.65)",
    background: "rgba(255,255,255,0.08)",
    color: "white",
    fontWeight: 1000,
    letterSpacing: 0.9,
    textTransform: "uppercase",
    cursor: "pointer",
  }}
>
  {t("register.back")}
</button>

<label
  style={{
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    marginTop: 6,
    padding: "4px 4px 0 4px",
    cursor: "pointer",
  }}
>
  <input
    type="checkbox"
    checked={confirmedMinimumAge}
    onChange={(e) => setConfirmedMinimumAge(e.target.checked)}
    style={{
      marginTop: 3,
      width: 18,
      height: 18,
      cursor: "pointer",
      flexShrink: 0,
    }}
  />

  <span
    style={{
      fontSize: 13,
      lineHeight: "1.5",
      color: "rgba(255,255,255,0.92)",
      fontWeight: 800,
    }}
  >
    {t("register.minimumAgeConfirmation")} *
  </span>
</label>

<div
  style={{
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    marginTop: 6,
    padding: "4px 4px 0 4px",
  }}
>
  <input
    type="checkbox"
    checked={acceptedLegal}
    onChange={(e) => setAcceptedLegal(e.target.checked)}
    style={{
      marginTop: 3,
      width: 18,
      height: 18,
      cursor: "pointer",
      flexShrink: 0,
    }}
  />

  <div
  style={{
    fontSize: 13,
    lineHeight: "1.5",
    color: "rgba(255,255,255,0.92)",
    fontWeight: 700,
  }}
>
  {t("register.acceptPrefix")}{" "}
  
	  <Link
	    to="/agb"
	    onClick={rememberRegisterReturn}
	    style={{
	      color: "#ff4fd8",
	      textDecoration: "underline",
      fontWeight: 900,
    }}
  >
    {t("register.terms")}
  </Link>{" "}
  
  {t("register.acceptMiddle")}{" "}
  
	  <Link
	    to="/datenschutz"
	    onClick={rememberRegisterReturn}
	    style={{
	      color: "#ff4fd8",
	      textDecoration: "underline",
      fontWeight: 900,
    }}
  >
    {t("register.privacy")}
  </Link>{" "}
  
  {t("register.acceptSuffix")} *
</div>
</div>

<div
  style={{
    marginTop: -2,
    paddingLeft: 34,
    color: "rgba(255,255,255,0.62)",
    fontSize: 12,
    fontWeight: 800,
  }}
>
  {t("register.requiredFieldHint")}
</div>

<div
  style={{
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    marginTop: 10,
    padding: "4px 4px 0 4px",
  }}
>
  <input
    type="checkbox"
    checked={canUseAiConflictAnalysis && aiConflictAnalysisConsent}
    disabled={!canUseAiConflictAnalysis}
    onChange={(e) => {
      if (!canUseAiConflictAnalysis) {
        setAiConflictAnalysisConsent(false);
        return;
      }
      setAiConflictAnalysisConsent(e.target.checked);
    }}
    style={{
      marginTop: 3,
      width: 18,
      height: 18,
      cursor: canUseAiConflictAnalysis ? "pointer" : "not-allowed",
      flexShrink: 0,
    }}
  />

  <div
    style={{
      fontSize: 13,
      lineHeight: "1.5",
      color: "rgba(255,255,255,0.86)",
      fontWeight: 700,
      opacity: canUseAiConflictAnalysis ? 1 : 0.62,
    }}
  >
    <strong style={{ color: "white", display: "block", marginBottom: 2 }}>
      {t("register.aiConflictConsentTitle")}
    </strong>
    {t("register.aiConflictConsentTextBeforePrivacy")}{" "}
    <Link
      to="/datenschutz"
      onClick={rememberRegisterReturn}
      style={{
        color: "#ff4fd8",
        textDecoration: "underline",
        fontWeight: 900,
      }}
    >
      {t("register.privacy")}
    </Link>
    {t("register.aiConflictConsentTextAfterPrivacy")}
    {!canUseAiConflictAnalysis && (
      <span style={{ display: "block", marginTop: 6, color: "#ffcf5a", fontWeight: 900 }}>
        {t("register.aiConflictConsentAdultOnly")}
      </span>
    )}
  </div>
</div>



        <button
          type="button"
         onClick={() => {
  if (!acceptedLegal) {
  onRegister?.({
    username,
    age,
    email,
    password,
    passwordRepeat,
    consoleType,
    confirmedMinimumAge,
    acceptedLegal: false,
    aiConflictAnalysisConsent: canUseAiConflictAnalysis && aiConflictAnalysisConsent,
  });
    return;
  }

  onRegister?.({
    username,
    age,
    email,
    password,
    passwordRepeat,
    consoleType,
    confirmedMinimumAge,
    acceptedLegal: true,
    aiConflictAnalysisConsent: canUseAiConflictAnalysis && aiConflictAnalysisConsent,
  });
}}
          style={{
            marginTop: 10,
            width: "100%",
            height: 70,
            borderRadius: 999,
            border: "none",
            background:
              "linear-gradient(90deg, #ff007f 0%, #7a2bff 100%)",
            color: "white",
            fontWeight: 1000,
            fontSize: 22,
            letterSpacing: 1,
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          {t("register.submit")}
        </button>
        {error && (
  <div
    style={{
      marginTop: 12,
      color: "#ff4d4f",
      fontWeight: 900,
      fontSize: 14,
      letterSpacing: 0.4,
      textAlign: "center",
      textTransform: "uppercase",
    }}
  >
    {error}
  </div>
)}
      </div>
    </div>
  </div>
</div>
    

        {/* Back to Login (optional) */}
        {step === 1 && renderBackToLoginButton()}
      </div>
    </div>
  );
}


function VQInput({ placeholder, type = "text", value, onChange }) {
  return (
    <div
      style={{
        height: 62,
        borderRadius: 18,
        background: "white",
        display: "flex",
        alignItems: "center",
        padding: "0 18px",
        boxSizing: "border-box",
      }}
    >
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{
          border: "none",
          outline: "none",
          width: "100%",
          fontSize: 16,
          fontWeight: 900,
          letterSpacing: 0.6,
          fontStyle: "italic",
          color: "#222",
          background: "transparent",
          textTransform: "uppercase",
        }}
      />
    </div>
  );
}
